export default "__VITE_PUBLIC_ASSET__983582e0__"